const UPPERCASE_START = /^\p{Lu}/u;
const LETTER_OR_DIGIT = /[\p{L}\p{N}]/gu;

function firstCharacter(word: string): string {
  return Array.from(word)[0] ?? "";
}

function words(text: string): string[] {
  return text.trim().split(/\s+/).filter(Boolean);
}

/**
 * The two letters a utility's monogram tile prints: the initials of the first
 * two words that begin with an uppercase letter ("Town of Marana" is TM), else
 * the first two letters or digits of the name ("marana" is MA). Uppercased.
 */
export function monogram(orgName: string): string {
  const capitalized = words(orgName).filter((word) => UPPERCASE_START.test(word));
  const [first, second] = capitalized;
  if (first !== undefined && second !== undefined) {
    return (firstCharacter(first) + firstCharacter(second)).toUpperCase();
  }
  return (orgName.match(LETTER_OR_DIGIT) ?? []).slice(0, 2).join("").toUpperCase();
}

/**
 * A person's initials: the first letters of the first and last words of the
 * full name (one letter for a one-word name), else the first letter of the
 * email. Uppercased.
 */
export function personInitials(fullName: string | null | undefined, email: string): string {
  const parts = words(fullName ?? "");
  const first = parts[0];
  if (first === undefined) return firstCharacter(email.trim()).toUpperCase();
  const last = parts.length > 1 ? parts[parts.length - 1] : undefined;
  return (firstCharacter(first) + (last === undefined ? "" : firstCharacter(last))).toUpperCase();
}
